import { Outlet } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AgeGateScreen } from "../components/AgeGateScreen";
import { isAgeGateSatisfiedForSlug } from "../lib/age-gate-session";

type LayoutProps = {
  dispensarySlug: string;
};

/**
 * §15.1 — Full-screen age gate before any shop route under **`/:dispensarySlug/*`**.
 */
export function DispensaryAgeLayout(props: LayoutProps) {
  const { dispensarySlug } = props;
  const [verified, setVerified] = useState(() => isAgeGateSatisfiedForSlug(dispensarySlug));

  useEffect(() => {
    setVerified(isAgeGateSatisfiedForSlug(dispensarySlug));
  }, [dispensarySlug]);

  if (!verified) {
    return (
      <AgeGateScreen
        dispensarySlug={dispensarySlug}
        onVerified={() => setVerified(true)}
      />
    );
  }

  return <Outlet />;
}
